// Skip to main content link for keyboard navigation accessibility

export default function SkipToContent() {
  const handleSkip = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      main.focus();
      main.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleSkip}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] bg-cyan text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-cyan focus:ring-offset-2 font-medium"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
}
